import React from 'react';

import { Badge, Box, Tooltip } from '../../core-ui';
import { Tag } from '../../types/shared/Tag';

export function TagLabelView(props: { tag: Tag }) {
  const { name, color } = props.tag;
  return (
    <Badge
      color="white"
      textShadow="1px 1px 2px rgba(0, 0, 0, .2)"
      backgroundColor={color}
    >
      {name}
    </Badge>
  );
}

export function TagView(props: { tag: Tag }) {
  const { name, color } = props.tag;
  const size = 4;
  return (
    <Tooltip label={name} placement="top">
      <Box
        width={size}
        height={size}
        borderRadius={2}
        backgroundColor={color}
      />
    </Tooltip>
  );
}
